import {
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  MAT_DIALOG_DATA,
  PageEvent,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
import * as moment from "moment";
import { BetInfo, Category } from "src/_models/bet";
import { AppService } from "src/_services/app.service";
import { BetMonitorStatusList } from "../../../_constants/bet_filters";
import { Router } from "@angular/router";
import { User } from "src/_models";
import { SapRoles, roleTypeGroup } from "src/_constants/roleType";
import { Observable, Subscription, interval } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthenticationService } from "src/_services/authentication.service";

export interface DialogData {
  betInfo: BetInfo;
}
@Component({
  selector: "app-bets-monitoring",
  templateUrl: "./bets-monitoring.component.html",
  styleUrls: ["./bets-monitoring.component.scss"],
})
export class BetsMonitoringComponent implements OnInit {
  private readonly pollingInterval = 3000; // 3 seconds
  private pollingSubscription: Subscription | undefined;
  betDisplayedColumns: string[] = [
    "Date",
    "Username",
    "Sports",
    "Event",
    "OperatorId",
    "MarketType",
    "Odds",
    "Stake",
    "currency",
    "status",
    "Returns",
    "IP",
    "Origin",
    // "action"
  ];

  today = new Date();
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  formDate = new FormControl(this.today);
  toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  bets = new MatTableDataSource<any>();
  users: User[] = [];
  filterUsers: User[] = [];
  totalRecords: number;
  searchUserName: string = "all";
  sapRoles = SapRoles;
  sports = [];
  showAlert: any = false;
  betStatusList = BetMonitorStatusList;
  selectedProvider = "";
  selectedSport = new FormControl([]);
  events = [];
  markets = [];
  selectedBetStatus = new FormControl([BetMonitorStatusList[0]]);
  selectedUserName = "";
  selectedIP = "";
  inputMarket = "";
  selectedStake = "";
  selectedEvent = "";
  selectedMarket = new FormControl([]);
  origin = new FormControl([]);
  allSportsSelected = false;
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  selected: any = {
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  ProviderId = new FormControl([]);
  OperatorId= new FormControl([]);
  category = new FormControl([]);
  operatorData = [];
  length: any = 0;
  dropdownSettings: any = {};
  operatorSettings: any = {};
  sportSettings: any = {};
  eventSettings:any = {};
  marketSettings: any = {};
  statusSettings: any = {};
  stakefilter: boolean = false;
  useridfilter: boolean = false;
  ipfilter: boolean = false;
  eventidfilter: boolean = false;
  marketidfilter: boolean = false;
  originfilter: boolean = false;
  categoryfilter: boolean = false;
  categories = Category;
  origins = ["SPORTSBOOK","PREMIUM","VIRTUAL","EXPREMIUM"]
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  ipfill() {
    this.ipfilter = true;
  }
  useridfill() {
    this.useridfilter = true;
  }
  stakefill() {
    this.stakefilter = true;
  }
  eventidfill() {
    this.eventidfilter = true;
  }
  originfill() {
    this.originfilter = true;
  }
  categoryfill() {
    this.categoryfilter = true;
  }

  marketidfill() {
    this.marketidfilter = true;
  }
  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.operatorSettings = {
      singleSelection: false,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.eventSettings = {
      singleSelection: true,
      idField: "event_id",
      textField: "customText",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    }
    this.marketSettings = {
      singleSelection: true,
      idField: "marketId",
      textField: "marketName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    }
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    }
    this.startPolling();
    sessionStorage.setItem("TotalBets", "0");
    this.getOperatorData();
    this.getAdminProviders();
  }

  changeTableColumns() {
    this.betDisplayedColumns =
    this.userRole.role === this.sapRoles.SAPAdmin ||
    roleTypeGroup.includes(this.userRole.role) ||
    this.userRole.role === this.sapRoles.RiskAdmin
    ? this.ProviderId.value[0] === "SportsBook" ?
    [
      "Date",
      "Username",
      "Event",
      "OperatorId",
      "MarketType",
      "Odds",
      "Stake",
      "IP",
      "Origin",
    ]
      : [
        "Date",
        "Username",
        "Event",
        "OperatorId",
        "MarketType",
        "Odds",
        "Stake",
        "Returns",
        "IP",
      ]
      : this.ProviderId.value[0] === "SportsBook" ?[
        "Date",
        "Username",
        "Event",
        "MarketType",
        "Odds",
        "Stake",
        "IP",
        "Origin",
      ]: [
        "Date",
        "Username",
        "Event",
        "MarketType",
        "Odds",
        "Stake",
        "Returns",
        "IP",
      ]
  }

  onItemSelect(event){
    console.log("Event",event)
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  private startPolling(): void {
    this.pollingSubscription = interval(this.pollingInterval)
      .pipe(
        takeUntil(
          Observable.create((observer) => (this.pollingSubscription = observer))
        )
      )
      .subscribe(() => {
        this.getBetList();
      });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  alertModal(betDetails: BetInfo) {
    let dialogRef = this.dialog.open(AlertModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        betInfo: betDetails,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getBetList();
    });
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  onSelectedBetsType = (data) => {
    this.page = 1;
    this.paginator.pageIndex = 0;
    this.selectedBetStatus.setValue([data]);
    this.getBetList();
  };

  getAdminProviders() {
    if (
      this.userRole.role === this.sapRoles.SAPAdmin ||
      this.userRole.role === this.sapRoles.SAPUser
    ) {
      this.providers = ["Exchange", "SportsBook", "GeniusPremium"];
    }
    this.onSelectedProvider(this.providers[0]);
  }

  truncate(value: string, limit: number): string {
    if (value.length > limit) {
      return value.slice(0, limit) + (value.length > limit ? '...' : '');
    }
    return value;
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getBetList();
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
              fb = b.operator_id.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          })
          .map((operator) => {
            return operator.operator_id;
          });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          const cricketIndex = this.sports.findIndex(sport => sport.SportName.toLowerCase() === 'cricket');
          this.selectedSport.setValue([this.sports[cricketIndex]]);
          this.onFilterChange();
          // this.getEvents();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.ProviderId.setValue([pid]);
    this.changeTableColumns();
    this.selectedEvent = "";
    this.selectedMarket.setValue([]);
  };

  onSelectedOperatorId = (OperatorId) => {
    // this.getEvents();
    this.OperatorId.setValue([OperatorId]);
    this.onFilterChange();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment().startOf("day");
        this.selected.endDate = moment().endOf("day");
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      } else if (this.selected.startDate !== null) {
        this.onChangeSports()
      }
    }
  };

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getBetList();
  }

  copyText(val: string){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

    tranformSports(data){
      console.log(data)
      return data
    }

  saveUserId(value) {
    let user = value.operatorId + "-" + value.userId
    this.flagUser(user,"",value.userFlag)
  }

  saveUserIp(value) {
    this.flagUser("", value.ip,value.ipFlag)
  }

  flagUser(key, ip,flag) {
    let filters = {
      userKey: key ? key : "",
      ip: ip ? ip : "",
      flag : !(flag),
    };
    this.appService.flagUser(filters).subscribe((res) => {
      this.getBetList();
      if (res.status === "RS_OK") {
        this.appService.openSuccessBar(res.errorDescription);
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      }
    });
  }

  getBetList() {
    // console.log(this.selectedSport.value)
    const sportsIds = this.selectedSport.value.length === 0 ? this.sports.map(sport => sport.SportId) : this.selectedSport.value.map(sport => sport.SportId);
    let filters = {
      providerId: this.ProviderId.value[0],
      operatorId: this.OperatorId.value.length != 0 ? this.OperatorId.value : null,
      eventId: this.selectedEvent,
      origin: this.origin.value.length != 0 ? this.origin.value[0] : "",
      category: this.category.value.length != 0 ? this.category.value[0].id : "",
      // marketId: this.selectedMarket.value.length != 0 ? this.selectedMarket.value[0].marketId : "",
      marketId: this.inputMarket,
      userName: this.selectedUserName,
      sportName: this.selectedSport.value.length != 0 ? this.selectedSport.value[0].SportId : "",
      stake: parseFloat(this.selectedStake),
      ip: this.selectedIP,
      status: this.selectedBetStatus.value.length != 0? this.selectedBetStatus.value[0].id : "",
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      PageSize: this.orgPageSize,
      Page: this.page,
    };

    this.appService.getBetMonitorList(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.bets = new MatTableDataSource<any>(res.betList);
        // if (this.page == 1) {
        //   this.length = res.totalBets;
        // } else {
        //   this.paginator.length = this.length;
        // }
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      }
    });
  }

  getEvents() {
    let sports = this.selectedSport.value.map((sport) => sport.SportId)
    let filters = {
      providerId: this.ProviderId.value[0],
      sportName: sports,
      status: this.selectedBetStatus.value.length != 0? this.selectedBetStatus.value[0].id : "",
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getBetMonitorEvents(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.events = res.events
        this.events.forEach(event => {
          event.customText = `${this.getEventDate(event.open_date)} ${event.event_name}`;
        });
      }
    });
  }

  getMarkets() {
    let sports = this.selectedSport.value.map((sport)=> sport.SportId)
    let filters = {
      providerId: this.ProviderId.value[0],
      sportName: sports,
      status: this.selectedBetStatus.value.length != 0? this.selectedBetStatus.value[0].id : "",
      eventId: this.selectedEvent,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getBetMonitorMarkets(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.markets = res.markets;
      }
    });
  }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  };

  getEventDate = (date: number) => {
    return moment(date).format("DD-MM-YYYY");
  };

  onChangeSports(type: string = "") {
    if(type === 'all'){
      const cricketIndex = this.sports.findIndex(sport => sport.SportName.toLowerCase() === 'cricket');
      this.selectedSport.setValue([this.sports[cricketIndex]]);
    }
    this.events = [];
    this.selectedEvent= "";
    this.selectedMarket.setValue([]);
    // this.getEvents();
    // this.onFilterChange();
  }

  onChangeEvent() {
    this.selectedMarket.setValue([]);
    // this.getMarkets();
    this.onFilterChange();
  }

  onChangeMarket() {
    this.onFilterChange();
  }

  onChangeUser() {
    console.log("Betlist");
    this.getBetList();
  }

  onChangeStatus() {
    this.selectedBetStatus.setValue([BetMonitorStatusList[0]])
  }

  onUserSelection(user: User) {
    this.selectedUserName = user.userId;
    this.onFilterChange();
  }

  onUserSelectionClear() {
    if (this.selectedUserName == "" || this.selectedUserName == null) {
      this.useridfilter = false;
    }
    this.selectedUserName = "";
  }

  onIPSelection(value) {
    this.selectedIP = value.trim();
  }

  onMarketSelection(value) {
    this.inputMarket = value.trim();
  }
  onEventSelection(value) {
    if (this.selectedSport.value.length !== 0) {
    this.eventidfilter = true;
    this.selectedEvent = value.trim();
    }
  }

  onIPSelectionClear() {
    if (this.selectedIP == "" || this.selectedIP == null) {
      this.ipfilter = false;
    }
    this.selectedIP = "";
  }

  onEventSelectionClear() {
    if (this.selectedEvent == "" || this.selectedEvent == null) {
      this.eventidfilter = false;
    }
    this.selectedEvent = "";
  }

  onMarketSelectionClear() {
    if (this.inputMarket == "" || this.inputMarket == null) {
      this.marketidfilter = false;
    }
    this.inputMarket = "";
  }

  onStakeSelection(value) {
    this.selectedStake = value;
  }

  onStakeSelectionClear() {
    if (this.selectedStake == "" || this.selectedStake == null) {
      this.stakefilter = false;
    }
    this.selectedStake = "";
  }


  openDialog(betDetails: BetInfo) {
    this.dialog.open(BetDetailsComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        betInfo: betDetails,
      },
    });
  }
}
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./bet_info_modal.component.html",
  styleUrls: ["./bets-monitoring.component.scss"],
})
export class BetDetailsComponent {
  betInfo: BetInfo;
  betResponse: BetInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {
    if (data.betInfo) {
      this.betInfo = data.betInfo;
    }
  }

  ngOnInit() {
    if (this.betInfo.transactionId) {
      this.appService
        .getBetInfo(this.betInfo.transactionId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.betResponse = res.betReportDetail;
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              // this.router.navigateByUrl("/login");
            }
          }
        });
    }
  }

  copyText(val: string){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

  copyEvent() {
    return this.betInfo.sportName + "/" + this.betInfo.eventName
  }

  betOn() {
    const value = this.betInfo.marketType === "FANCY" ? "FANCY" :
    this.betInfo.marketName + "/" +
    (this.betInfo.marketType === "FANCY" ?
    this.betInfo.runnerName + "@" + this.betResponse.odds :
    this.betInfo.runnerName);

    return value;
  }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  };
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./alert_modal.component.html",
  styleUrls: ["./bets-monitoring.component.scss"],
})
export class AlertModalComponent {
  betInfo: BetInfo;
  remarks = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService,
    private authenticationService: AuthenticationService,) {
    if (data.betInfo) {
      this.betInfo = data.betInfo;
    }
  }

  ngOnInit() {}

  submitRemarks() {
    if (this.betInfo.transactionId) {
      this.appService
        .alertBet(this.betInfo.transactionId, this.remarks)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.authenticationService.openSnackBar("Bet Alerted");
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
            }
          }
        });
    }
  }
}
